import React from 'react'
import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { formatBatteryTimeRemaining } from '../../../../helpers'
import { MetricWidget } from '../components/MetricWidget'
import { formatDecimal } from '../utils'

const InverterSections = ({ equipment }) => {
  const { t } = useTranslation()
  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(3, minmax(0, 1fr))' }, gap: 2 }}>
      <MetricWidget title={t('supervision.card.inverter.battery_percentage')} value={equipment.battery_charge == null ? null : formatDecimal(equipment.battery_charge)} unit="%" icon="fa-solid fa-battery-bolt" progress={equipment.battery_charge == null ? null : Number(equipment.battery_charge)} showProgress />
      <MetricWidget title={t('supervision.card.inverter.battery_remaining_autonomy')} value={equipment.battery_time_remaining == null ? null : formatBatteryTimeRemaining(equipment.battery_time_remaining)} icon="fa-solid fa-hourglass" />
      <MetricWidget title={t('supervision.card.inverter.power_consumption')} value={equipment.total_load == null ? null : formatDecimal(equipment.total_load)} unit="W" icon="fa-solid fa-plug-circle-bolt" />
    </Box>
  )
}

export default InverterSections
